// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmailTemplateThemeDto
 */
export interface IEmailTemplateThemeDto {
    /**
     * 
     * @type {number}
     * @memberof IEmailTemplateThemeDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEmailTemplateThemeDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmailTemplateThemeDto
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmailTemplateThemeDto
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmailTemplateThemeDto
     */
    active_link?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmailTemplateThemeDto
     */
    button_background?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmailTemplateThemeDto
     */
    button_text?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmailTemplateThemeDto
     */
    code_text?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmailTemplateThemeDto
     */
    code_background?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmailTemplateThemeDto
     */
    organization_path?: string;
}

/**
 * Check if a given object implements the IEmailTemplateThemeDto interface.
 */
export function instanceOfIEmailTemplateThemeDto(value: object): value is IEmailTemplateThemeDto {
    return true;
}

export function IEmailTemplateThemeDtoFromJSON(json: any): IEmailTemplateThemeDto {
    return IEmailTemplateThemeDtoFromJSONTyped(json, false);
}

export function IEmailTemplateThemeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmailTemplateThemeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'subject': json['subject'] == null ? undefined : json['subject'],
        'text': json['text'] == null ? undefined : json['text'],
        'active_link': json['active_link'] == null ? undefined : json['active_link'],
        'button_background': json['button_background'] == null ? undefined : json['button_background'],
        'button_text': json['button_text'] == null ? undefined : json['button_text'],
        'code_text': json['code_text'] == null ? undefined : json['code_text'],
        'code_background': json['code_background'] == null ? undefined : json['code_background'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
    };
}

export function IEmailTemplateThemeDtoToJSON(json: any): IEmailTemplateThemeDto {
    return IEmailTemplateThemeDtoToJSONTyped(json, false);
}

export function IEmailTemplateThemeDtoToJSONTyped(value?: IEmailTemplateThemeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'subject': value['subject'],
        'text': value['text'],
        'active_link': value['active_link'],
        'button_background': value['button_background'],
        'button_text': value['button_text'],
        'code_text': value['code_text'],
        'code_background': value['code_background'],
        'organization_path': value['organization_path'],
    };
}

